var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.76 17.76H6.24001V14.88H4.32001V18.72C4.32001 18.975 4.42126 19.2187 4.60126 19.3987C4.78127 19.5787 5.02501 19.68 5.28001 19.68H18.72C18.975 19.68 19.2188 19.5788 19.3988 19.3987C19.5788 19.2187 19.68 18.975 19.68 18.72V14.88H17.76V17.76Z",
    fill: "#003A5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0401 4.31904L11.0401 12.5606L9.12009 10.6406L7.76164 11.9991L11.3213 15.5578C11.5013 15.7387 11.7451 15.84 12.0001 15.84C12.2551 15.84 12.4988 15.7387 12.6788 15.5578L16.2385 11.9991L14.88 10.6406L12.96 12.5606L12.96 4.31904H11.0401Z",
    fill: "#003A5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ada7a5ab72364ef6b1a55b20e6a4565e.svg";
export { ForwardRef as ReactComponent };